'use strict'

/**
 * Module qui gère la validation des différents éléments d'un formulaire
 */

import ajaxLoader from 'Modules/ajaxLoader'

const J_INPUT_CLASS = '.j_input'
const J_EMAIL_INPUT_TYPE = 'j_email'
const J_INTEGER_INPUT_TYPE = 'j_integer'
const J_PARAM_NAME = 'parameter'

/*
 * Cette fonction vérifiera chaque élément j_input du j_form de la page
 * Elle procédera aux différents vérifications selon le type d'input.
 * La callback failCheckFormatCallback sera exécuter si un input n'est pas correct
 * Puis elle va appeler ajaxLoader.loadAndExecuteCallBack qui va
 * effectuer un appel AJAX sur 'action' et executer successCallbackAjax ou failCallbackAjax selon si l'appel réussi ou échoue
 */
function process(
    successCallbackAjax,
    failCallbackAjax,
    failCheckFormatCallback,
    action,
    jForm
) {
    const $formInputs = $(jForm).find('input' + J_INPUT_CLASS)
    const paramsToSend = {}
    let isFalseValue = false

    $formInputs.each(function (index, inputElement) {
        if ($(inputElement).hasClass(J_EMAIL_INPUT_TYPE)) {
            // Si il s'agit d'un champ email
            if (!isValideEmail(inputElement.value)) {
                failCheckFormatCallback($t('INVALIDEMAIL'))
                isFalseValue = true
                return false
            } else {
                paramsToSend[$(inputElement).data(J_PARAM_NAME)] =
                    $(inputElement).val() // Paramètre à envoyer à la fonction du controller
            }
        }

        if ($(inputElement).hasClass(J_INTEGER_INPUT_TYPE)) {
            // Si il s'agit d'un champ int
            if (!isValideInteger(inputElement.value)) {
                failCheckFormatCallback($('INVALIDINTEGER'))
                isFalseValue = true
                return false
            } else {
                paramsToSend[$(inputElement).data(J_PARAM_NAME)] =
                    $(inputElement).val() // Paramètre à envoyer à la fonction du controller
            }
        }
        // Rajouter une fonction et un if pour vérifier un nouvel élément
    })

    // si les valeurs des inputs sont valides, on submit le form. Si un callback est présent, il sera exécuté lorsque le POST aura réussi
    if (isFalseValue === false) {
        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            paramsToSend,
            successCallbackAjax,
            failCallbackAjax,
            action
        )
    }
}

function isValideEmail(email) {
    const regexPattern =
        /^([a-zA-Z0-9_\-.]+)@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})(]?)+$/
    return regexPattern.test(email)
}

function isValideInteger(integer) {
    const regexPattern = /^([0-9-])+$/
    return regexPattern.test(parseInt(integer))
}

function hasSpecialChar(str) {
    const regexPattern =
        /([^a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\s])+/
    return regexPattern.test(str)
}

export default {
    process: process,
    isValideEmail: isValideEmail,
    hasSpecialChar: hasSpecialChar
}
